export const locale = {
  closeButtonLabel: 'Close Side Menu',
  logoTitle: 'Marathon Health Home',
  homePageLabel: 'Marathon Health Home Page',
  logoLabel: 'This is the official logo',
};
